import React, { useEffect } from 'react';
import { Flex } from '@tremor/react';
import { usePopup } from '../../contexts/PopupContext';
import { useUserStatus } from '../../hooks/useUserStatus';
import { useNotificationCount } from '../../hooks/useNotificationCount';
import { useUserPrivacySettings } from '../../hooks/useUserPrivacySettings';
import { useLastSeenHeartbeat } from '../../hooks/useLastSeenHeartbeat';
import InactiveAccountView from '../profile/settings/InactiveAccountView';
import Header from './Header';
import BottomNavigation from './BottomNavigation';
import Loading from './Loading';
import './PrivateLayout.css';

function MainWithCornerFill({ children }) {
  return (
    <div className="private-content-shell">
      <span className="private-content-corner private-content-corner--tl" aria-hidden="true" />
      <span className="private-content-corner private-content-corner--tr" aria-hidden="true" />
      <span className="private-content-corner private-content-corner--bl" aria-hidden="true" />
      <span className="private-content-corner private-content-corner--br" aria-hidden="true" />
      <main className="private-content">{children}</main>
    </div>
  );
}

function PrivateLayout({ children, activeTab, setActiveTab, onLogout, hideNavigation = false }) {
  const { isActive, isLoading } = useUserStatus();
  const { count: notificationCount } = useNotificationCount();
  const { hideLastActivity, isLoading: privacyLoading } = useUserPrivacySettings();
  const { closeAllPopups, setAccountPopupsRestricted } = usePopup();
  useLastSeenHeartbeat(!isLoading && isActive && !privacyLoading && !hideLastActivity);

  useEffect(() => {
    if (isLoading) return;
    const restricted = !isActive;
    setAccountPopupsRestricted(restricted);
    if (restricted) {
      closeAllPopups();
    }
  }, [isLoading, isActive, closeAllPopups, setAccountPopupsRestricted]);

  // Jeśli sprawdzamy status, pokaż loading
  if (isLoading) {
    return (
      <div className="private-layout">
        <Loading fullScreen size="large" />
      </div>
    );
  }

  // Jeśli konto jest nieaktywne, pokaż widok nieaktywnego konta
  if (!isActive) {
    return (
      <div className="private-layout">
        <Header
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          onLogout={onLogout}
          accountRestricted
        />
        <MainWithCornerFill>
          <InactiveAccountView />
        </MainWithCornerFill>
        {!hideNavigation && (
          <BottomNavigation
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            notificationCount={notificationCount}
            accountRestricted
            onLogout={onLogout}
          />
        )}
      </div>
    );
  }

  // Normalny widok dla aktywnego konta
  return (
    <Flex className="private-layout" flexDirection="col">
      <Header activeTab={activeTab} setActiveTab={setActiveTab} onLogout={onLogout} accountRestricted={false} />
      <MainWithCornerFill>{children}</MainWithCornerFill>
      {!hideNavigation && (
        <BottomNavigation
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          notificationCount={notificationCount}
          accountRestricted={false}
          onLogout={onLogout}
        />
      )}
    </Flex>
  );
}

export default PrivateLayout;


